
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        to: {
            type: String,
            required: true,
        },
        directLink: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideBorder: {
            type: Boolean,
            required: false,
            default: false,
        },
        openInNewTab: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        isExternal() {
            return this.to.startsWith('http');
        },
    },
};
